<template lang="pug">
div.wrap-item-combobox.relative
  v-combobox(ref="combobox"
    v-model="tags"
    :search-input.sync="search"
    :label="label"
    :placeholder="placeholder" persistent-placeholder
    :hint="hint"
    :rules="[() => tags.length <= maxTagsNum ||`${maxTagsNum}個以内のタグを設定してください`]"
    hide-selected multiple small-chips outlined
    @keydown.stop="onKeydown"
    @focus="showCandidates = true" @blur="onBlur"
    append-icon="")
    template(v-slot:selection="{ item }")
      v-chip
        span.mr4 {{'#' + item}}
        v-icon(@click="removeTag(item)" size="18") mdi-close
  div(v-if="showCandidates && tagsCandidates[0]"
    ).wrap-candidates.absolute.w-full.t58.rounded.overflow-scroll
    div(v-for="(tag, index) in tagsCandidates"
      :class="{'is-highlighted': highlightedCandidateIndex == index}"
      @click.stop="onCandidate(tag)").candidate.f.fm.flex-between.px20.py12.cursor-pointer
      span.fz16 {{'#' + tag.value}}
      span.num.fz14 {{tag.num}}件
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-combobox {
  .wrap-candidates {
    z-index: 100;
    top: calc(100% - 24px);
    max-height: 264px;
    background: $primary_bg_color;
    border: $basic_border;
    filter: $drop_shadow;
    .candidate {
      &.is-highlighted {
        background: $secondary_bg_color;
      }
      .num {
        color: $secondary_text_color;
      }
    }
  }
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    tagType: {
      type: String,
      required: true
    },
    initialTags: {
      type: Array,
      required: false
    },
    maxTagsNum: {
      type: Number,
      default: 10
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapStateAuth(['uid', 'isAdmin'])
  },
  watch: {
    async search () {
      if (this.searchTimer) clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(this.searchTags, 400)
    },
    tags () {
      const tagsWithHashtagStr = this.tags.filter(t => t.includes('#'))
      if (tagsWithHashtagStr[0]) {
        this.tags = this.tags.map(t => t.replaceAll('#', ''))
      }
      const tagsWithTooLongStr = this.tags.filter(t => t.length > this.tagMaxLength)
      if (tagsWithTooLongStr[0]) {
        this.tags = this.tags.filter(t => t.length <= this.tagMaxLength)
        this.$root.$emit('showNavigationMessage', {
          message: `タグは${this.tagMaxLength}字数以内です`, showOK: true
        })
      }
      // 全角スペースor半角スペースは消す
      const tagsWithSpaceStr = this.tags
        .filter(t => t.includes('　') || t.includes(' '))
      if (tagsWithSpaceStr[0]) {
        this.tags = this.tags.map(t => t.replaceAll(' ', ''))
        this.tags = this.tags.map(t => t.replaceAll('　', ''))
      }

      if (!this.isAdmin) {
        const tagsToBeExcluded = this.tags.filter(t => this.excludedTags.includes(t))
        if (tagsToBeExcluded[0]) {
          this.tags = this.tags.filter(t => {
            return !this.excludedTags.includes(t)
          })
          this.$root.$emit('showNavigationMessage', {
            message: `「#${tagsToBeExcluded[0]}」はタグとして利用できません`, showOK: true
          })
        }
      }
    }
  },
  data () {
    return {
      tags: [],
      tagsCandidates: [],
      limit: 10,
      search: '',
      showCandidates: false,
      highlightedCandidateIndex: -1,
      // preventOnBlur: false,
      searchTimer: null,
      excludedTags: ['公式'],
      tagMaxLength: 20,
      // rules: [
      //   v => !!v || '',
      //   v => v.length <= this.tagMaxLength || ''
      // ],
    }
  },
  async created () {
    this.tags = this.initialTags
    const tagsCandidates = await database.tagCollection()
      .getTagsByKeyword({
        keyword: ' ',
        types: [this.tagType],
        limit: this.limit
      })
    this.tagsCandidates = tagsCandidates
      .filter(t => !this.excludedTags.includes(t.value))
  },
  methods: {
    async searchTags () {
      const keyword = this.search !== null ?
        this.search.replace('#', '') : ''
      const yomigana = this.hiraToKana(keyword)
      // console.log('keyword:', keyword)
      const tagsCandidates = await database.tagCollection()
        .getTagsByKeyword({
          keyword,
          yomigana,
          types: [this.tagType],
          limit: this.limit
        })
      this.tagsCandidates = tagsCandidates
        .filter(t => !this.tags.includes(t.value))
        .filter(t => !this.excludedTags.includes(t.value))
      // console.log('this.tagsCandidates:', this.tagsCandidates)
    },
    removeTag (tag) {
      this.tags = this.tags.filter(t => t !== tag)
    },
    hiraToKana (str) {
      return str.replace(/[\u3041-\u3096]/g, (match) => {
        var chr = match.charCodeAt(0) + 0x60
        return String.fromCharCode(chr)
      })
    },
    onKeydown (e) {
      this.showCandidates = true
      if (e.key === 'ArrowDown') {
        if (this.highlightedCandidateIndex < this.tagsCandidates.length - 1) {
          this.highlightedCandidateIndex++
        } else {
          this.highlightedCandidateIndex = 0
        }
      }
      if (e.key === 'ArrowUp') {
        if (this.highlightedCandidateIndex > 0) {
          this.highlightedCandidateIndex--
        } else {
          this.highlightedCandidateIndex = this.tagsCandidates.length - 1
        }
      }
      if (e.key === 'Enter' && this.highlightedCandidateIndex !== -1) {
        const tagToAdd = this.tagsCandidates[this.highlightedCandidateIndex]
        if (tagToAdd) {
          this.tags.push(tagToAdd.value)
          this.search = ''
          this.highlightedCandidateIndex = -1
        }
      }
    },
    onCandidate (tag) {
      // this.preventOnBlur = true
      this.search = ''
      this.tags.push(tag.value)
      this.$nextTick(async () => {
        await this.sleep(100)
        const combobox = this.$refs.combobox
        combobox.$refs.input.focus()
      })
      // console.log('onCandidate:', this.tags)
    },
    async onBlur () {
      // if (this.preventOnBlur) {
      //   this.preventOnBlur = false
      //   return
      // }
      await this.sleep(400)
      this.$nextTick(() => {
        this.showCandidates = false
      })
    },
    onConbobox (e) {
      debugger
    }
  }
}
</script>
